'use client';

import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { attachJourneyAutoplay } from '../lib/journey-autoplay';

export default function JourneyAutoplay({ root, mount, group, advance, locale }) {
  const [paused, setPaused] = useState(false);
  const [reducedMotion, setReducedMotion] = useState(false);
  const control = useRef(null);

  useEffect(() => attachJourneyAutoplay(root, () => advance(group), {
    paused,
    control,
    onMotionChange: setReducedMotion,
  }), [root, group, advance, paused]);

  if (reducedMotion) return null;
  const label = locale === 'tr'
    ? (paused ? 'Akışı devam ettir' : 'Akışı duraklat')
    : (paused ? 'Resume animation' : 'Pause animation');

  return createPortal(<button ref={control} type="button" className="story-autoplay" aria-label={label}
    onClick={() => setPaused(value => !value)}>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
      {paused ? <path d="M4 2.5v11L13 8z"/> : <path d="M4 3h3v10H4zm5 0h3v10H9z"/>}
    </svg>
    {locale === 'tr' ? (paused ? 'Devam et' : 'Duraklat') : (paused ? 'Resume' : 'Pause')}
  </button>, mount);
}
